import { animate, style, transition, trigger } from '@angular/animations';

export const fadeInAnimation = (time: string) =>
  trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate(time, style({ opacity: 1 }))])]);
